import {
  Box,
  Card,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Alert,
  Avatar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Tooltip,
  DialogTitle,
  TextField,
  CircularProgress
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import Label from '../Label';
import * as moment from 'moment';
import Scrollbar from '../Scrollbar';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import ArrowRightIcon from '../../icons/ArrowRight';
import DeleteIcon from '@mui/icons-material/Delete';
import GetAppIcon from '@mui/icons-material/GetApp';
import { useEffect, useState } from 'react';
import { campaignApi } from '../../api/campaignApi';
import { alpha } from '@mui/material/styles';
import { getTone, grey, lightVeil, toneAlpha } from '../../theme/tones';
// import { Formik, ErrorMessage } from 'formik';

const CampaignCard = (props) => {
  const { infoCommercial, commercial, setOpenReinjection, setOpenRetrieve, setSelectedCommercialReinjection, setSelectedCommercialRetrieve, idCampaign, numberProspectsAttribuable, ...other } = props;
  const theme = useTheme();
  const [openDelete, setOpenDelete] = useState(false);
  const [openAttribute, setOpenAttribute] = useState(false);
  const [commercialToDelete, setCommercialToDelete] = useState(null);
  const [commercialToAttribute, setCommercialToAttribute] = useState(null);
  const [nbToAttribute, setNbToAttribute] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    setNbToAttribute(numberProspectsAttribuable);
  }, [numberProspectsAttribuable]);
  function stringToColor(string) {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.substr(-2);
    }

    return color;
  }
  function stringAvatar(name) {
    return {
      sx: {
        bgcolor: stringToColor(name),
      },
      children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
    };
  }

  const dialogDeleteOpener = (callerId) => {
    setOpenDelete(true);
    setCommercialToDelete(callerId);
  };

  const handleCloseDialogDelete = () => {
    setOpenDelete(false);
  };

  const dialogAttributeOpener = (callerId) => {
    setOpenAttribute(true);
    setCommercialToAttribute(callerId);
  };

  const handleCloseDialogAttribute = () => {
    setOpenAttribute(false);
  };

  const handleDeleteCommercial = async () => {
    try {
      setIsLoading(true);
      await campaignApi.deleteCommercial(idCampaign, commercialToDelete, localStorage.getItem('accessToken'));
      setOpenDelete(false);
      setIsLoading(false);
      window.location.reload();
    } catch (err) {
      console.log(err);
    }
  };

  const attributeNotAttributedCommercial = async () => {
    try {
      setIsLoading(true);
      await campaignApi.attributeNotAttributedCommercial(idCampaign, commercialToAttribute, nbToAttribute, localStorage.getItem('accessToken'));
      setOpenAttribute(false);
      setIsLoading(false);
      window.location.reload();
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <Card
      {...other}
      sx={{
        borderRadius: '24px',
        boxShadow: (theme) => `0 4px 18px 0 ${alpha(theme.palette.common.black, 0.03)}`,
        border: '1px solid',
        borderColor: 'divider',
        overflow: 'hidden',
        ...other.sx
      }}
    >
      <Dialog
        open={openDelete}
        onClose={handleCloseDialogDelete}
        PaperProps={{ sx: { borderRadius: '20px', p: 1 } }}
      >
        <DialogContent>
          <DialogContentText sx={{ color: 'text.primary', fontWeight: 500 }}>
            Souhaitez-vous vraiment supprimer le commercial de la campagne ?
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={() => handleDeleteCommercial()}
            color="error"
            variant="contained"
            disabled={isLoading}
            sx={{ borderRadius: '10px', textTransform: 'none', fontWeight: 600 }}
          >
            Supprimer
          </Button>
          <Button
            onClick={handleCloseDialogDelete}
            color="inherit"
            variant="outlined"
            sx={{ borderRadius: '10px', textTransform: 'none', fontWeight: 600, borderColor: 'divider' }}
          >
            Annuler
          </Button>
          {isLoading && (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                ml: 2
              }}
            >
              <CircularProgress size={24} />
            </Box>
          )}
        </DialogActions>
      </Dialog>
      <Dialog
        open={openAttribute}
        onClose={handleCloseDialogAttribute}
        fullWidth
        maxWidth="sm"
        PaperProps={{ sx: { borderRadius: '20px', p: 1 } }}
      >
        <DialogTitle sx={{ fontWeight: 700 }}>Attribuer les apprenants non attribués</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ mb: 2 }}>
            Choisissez un nombre à attribuer (maximum : {numberProspectsAttribuable})
          </DialogContentText>
          <TextField
            fullWidth
            type="number"
            autoFocus
            onChange={(event) => {
              setNbToAttribute(parseInt(event.target.value, 10));
            }}
            value={nbToAttribute}
            variant="outlined"
            InputProps={{ 
              inputProps: { max: numberProspectsAttribuable, min: 0 },
              sx: { borderRadius: '12px' }
            }}
          />
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={() => attributeNotAttributedCommercial()}
            variant="contained"
            disabled={nbToAttribute > numberProspectsAttribuable || nbToAttribute <= 0 || isLoading}
            sx={{
              background: (theme) => `linear-gradient(135deg, ${theme.palette.secondary.main} 0%, ${theme.palette.secondary.dark} 100%)`,
              color: grey(0),
              borderRadius: '10px',
              textTransform: 'none',
              fontWeight: 600,
              boxShadow: (theme) => `0 4px 12px 0 ${alpha(theme.palette.secondary.main, 0.25)}`,
              '&:hover': {
                background: (theme) => `linear-gradient(135deg, ${theme.palette.secondary.dark} 0%, ${theme.palette.secondary.dark} 100%)`
              }
            }}
          >
            Attribuer
          </Button>
          <Button
            onClick={handleCloseDialogAttribute}
            color="inherit"
            variant="outlined"
            sx={{ borderRadius: '10px', textTransform: 'none', fontWeight: 600, borderColor: 'divider' }}
          >
            Annuler
          </Button>
          {isLoading && (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                ml: 2
              }}
            >
              <CircularProgress size={24} />
            </Box>
          )}
        </DialogActions>
      </Dialog>
      <Scrollbar>
        <Box>
          <Table>
            <TableHead
              sx={{
                backgroundColor: theme.palette.mode === 'light' ? grey(50) : lightVeil(0.02),
                borderBottom: `2px solid ${theme.palette.divider}`
              }}
            >
              <TableRow>
                <TableCell
                  sx={{
                    fontWeight: 700,
                    color: theme.palette.mode === 'light' ? grey(600) : grey(400),
                    py: 2,
                    textTransform: 'uppercase',
                    fontSize: '0.75rem',
                    letterSpacing: '0.5px'
                  }}
                >
                  Nom
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: 700,
                    color: theme.palette.mode === 'light' ? grey(600) : grey(400),
                    py: 2,
                    textTransform: 'uppercase',
                    fontSize: '0.75rem',
                    letterSpacing: '0.5px'
                  }}
                >
                  Traité (Prospects)
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: 700,
                    color: theme.palette.mode === 'light' ? grey(600) : grey(400),
                    py: 2,
                    textTransform: 'uppercase',
                    fontSize: '0.75rem',
                    letterSpacing: '0.5px'
                  }}
                >
                  Vente
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    fontWeight: 700,
                    color: theme.palette.mode === 'light' ? grey(600) : grey(400),
                    py: 2,
                    textTransform: 'uppercase',
                    fontSize: '0.75rem',
                    letterSpacing: '0.5px'
                  }}
                >
                  Actions
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: 700,
                    color: theme.palette.mode === 'light' ? grey(600) : grey(400),
                    py: 2,
                    textTransform: 'uppercase',
                    fontSize: '0.75rem',
                    letterSpacing: '0.5px'
                  }}
                >
                  Moyenne de temps passé
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: 700,
                    color: theme.palette.mode === 'light' ? grey(600) : grey(400),
                    py: 2,
                    textTransform: 'uppercase',
                    fontSize: '0.75rem',
                    letterSpacing: '0.5px'
                  }}
                >
                  Total de temps passé
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: 700,
                    color: theme.palette.mode === 'light' ? grey(600) : grey(400),
                    py: 2,
                    textTransform: 'uppercase',
                    fontSize: '0.75rem',
                    letterSpacing: '0.5px'
                  }}
                >
                  Progression
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {infoCommercial !== undefined && Object.keys(infoCommercial).map((up) => (
                <TableRow
                  key={up}
                  sx={{
                    transition: 'background-color 0.2s ease',
                    '&:hover': {
                      backgroundColor: theme.palette.mode === 'light' ? toneAlpha('blue', 0.02) : lightVeil(0.02)
                    }
                  }}
                >
                  <TableCell sx={{ py: 2, width: 300, borderColor: 'divider' }}>
                    <Box
                      sx={{
                        alignItems: 'center',
                        display: 'flex'
                      }}
                    >
                      <Avatar
                        src={infoCommercial[up].avatar}
                        {...stringAvatar(`${up.split(' ')[0].replace(/ /g, '')} ${up.split(' ')[1].replace(/ /g, '')}`)}
                      />
                      <Typography
                        variant="subtitle2"
                        sx={{ ml: 2, fontWeight: 700, color: theme.palette.text.primary }}
                      >
                        {up}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell sx={{ py: 2, width: 180, borderColor: 'divider' }}>
                    <Alert
                      severity={(infoCommercial[up].treated / infoCommercial[up].general) >= 0.8 ? 'success' : (infoCommercial[up].treated / infoCommercial[up].general) <= 0.3 ? 'error' : 'warning'}
                      sx={{
                        py: 0,
                        px: 1.5,
                        display: 'inline-flex',
                        alignItems: 'center',
                        borderRadius: '8px',
                        '& .MuiAlert-icon': { mr: 1, fontSize: '18px' },
                        '& .MuiAlert-message': { py: 0.5, fontWeight: 600, fontSize: '0.825rem' }
                      }}
                    >
                      {infoCommercial[up].treated} / {infoCommercial[up].general}
                    </Alert>
                  </TableCell>
                  <TableCell sx={{ py: 2, width: 100, borderColor: 'divider' }}>
                    <Label
                      variant="h6"
                      color={infoCommercial[up].vente > 3 ? 'success' : infoCommercial[up].vente === 0 ? 'error' : 'warning'}
                      sx={{ fontSize: '0.875rem', px: 1.5, py: 0.5, fontWeight: 700 }}
                    >
                      {infoCommercial[up].vente}
                    </Label>
                  </TableCell>
                  <TableCell sx={{ py: 2, width: 220, borderColor: 'divider' }}>
                    <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
                      <Tooltip title="Réinjection">
                        <Button
                          variant="contained"
                          size="small"
                          onClick={() => {
                            setOpenReinjection(true);
                            setSelectedCommercialReinjection(infoCommercial[up].caller_id);
                          }}
                          sx={{
                            minWidth: 36,
                            width: 36,
                            height: 36,
                            p: 0,
                            borderRadius: '8px',
                            background: (theme) => `linear-gradient(135deg, ${theme.palette.success.main} 0%, ${theme.palette.success.main} 100%)`,
                            boxShadow: (theme) => `0 2px 8px 0 ${alpha(theme.palette.success.main, 0.2)}`,
                            color: grey(0),
                            '&:hover': {
                              background: `linear-gradient(135deg, ${getTone('emerald').color} 0%, ${getTone('emerald').color} 100%)`,
                              transform: 'translateY(-1px)'
                            }
                          }}
                        >
                          <RestartAltIcon fontSize="small" />
                        </Button>
                      </Tooltip>
                      <Tooltip title="Attribution non attribués">
                        <span>
                          <Button
                            disabled={numberProspectsAttribuable === 0}
                            variant="contained"
                            size="small"
                            onClick={() => {
                              dialogAttributeOpener(infoCommercial[up].caller_id);
                            }}
                            sx={{
                              minWidth: 36,
                              width: 36,
                              height: 36,
                              p: 0,
                              borderRadius: '8px',
                              background: (theme) => `linear-gradient(135deg, ${theme.palette.secondary.main} 0%, ${theme.palette.secondary.dark} 100%)`,
                              boxShadow: (theme) => `0 2px 8px 0 ${alpha(theme.palette.secondary.main, 0.2)}`,
                              color: grey(0),
                              '&:hover': {
                                background: (theme) => `linear-gradient(135deg, ${theme.palette.secondary.dark} 0%, ${theme.palette.secondary.dark} 100%)`,
                                transform: 'translateY(-1px)'
                              }
                            }}
                          >
                            <ArrowRightIcon fontSize="small" />
                          </Button>
                        </span>
                      </Tooltip>
                      <Tooltip title="Rattrapage">
                        <Button
                          variant="contained"
                          size="small"
                          onClick={() => {
                            setOpenRetrieve(true);
                            setSelectedCommercialRetrieve(infoCommercial[up].caller_id);
                          }}
                          sx={{
                            minWidth: 36,
                            width: 36,
                            height: 36,
 p: 0,
                            borderRadius: '8px',
                            background: (theme) => `linear-gradient(135deg, ${theme.palette.warning.main} 0%, ${theme.palette.warning.main} 100%)`,
                            boxShadow: (theme) => `0 2px 8px 0 ${alpha(theme.palette.warning.main, 0.2)}`,
                            color: grey(0),
                            '&:hover': {
                              background: `linear-gradient(135deg, ${getTone('amber').color} 0%, ${getTone('amber').color} 100%)`,
                              transform: 'translateY(-1px)'
                            }
                          }}
                        >
                          <GetAppIcon fontSize="small" />
                        </Button>
                      </Tooltip>
                      <Tooltip title="Suppression commercial">
                        <Button
                          variant="contained"
                          size="small"
                          onClick={() => {
                            dialogDeleteOpener(infoCommercial[up].caller_id);
                          }}
                          sx={{
                            minWidth: 36,
                            width: 36,
                            height: 36,
                            p: 0,
                            borderRadius: '8px',
                            background: (theme) => `linear-gradient(135deg, ${theme.palette.error.main} 0%, ${theme.palette.error.main} 100%)`,
                            boxShadow: (theme) => `0 2px 8px 0 ${alpha(theme.palette.error.main, 0.2)}`,
                            color: grey(0),
                            '&:hover': {
                              background: `linear-gradient(135deg, ${getTone('rose').color} 0%, ${getTone('rose').color} 100%)`,
                              transform: 'translateY(-1px)'
                            }
                          }}
                        >
                          <DeleteIcon fontSize="small" />
                        </Button>
                      </Tooltip>
                    </Box>
                  </TableCell>
                  <TableCell sx={{ py: 2, width: 180, borderColor: 'divider' }}>
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 600, color: theme.palette.text.secondary }}
                    >
                      {Number.isNaN(infoCommercial[up].time !== undefined && infoCommercial[up].totalTreated !== undefined ? parseInt(infoCommercial[up].time, 10) / infoCommercial[up].totalTreated : '') ? '00:00:00' : infoCommercial[up].totalTreated !== 0 ? moment.utc((infoCommercial[up].time !== undefined && infoCommercial[up].totalTreated !== undefined ? parseInt(infoCommercial[up].time, 10) / infoCommercial[up].totalTreated : '') * 1000).format('HH:mm:ss') : '00:00:00'}
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ py: 2, width: 180, borderColor: 'divider' }}>
                    <Typography variant="body2" sx={{ fontWeight: 600, color: theme.palette.text.secondary }}>
                      {moment.utc(infoCommercial[up].time * 1000).format('HH:mm:ss')}
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ py: 2, width: 280, borderColor: 'divider' }}>
                    <LinearProgress
                      value={((infoCommercial[up].treated / infoCommercial[up].general) * 100)}
                      variant="determinate"
                      color={(infoCommercial[up].treated / infoCommercial[up].general) >= 0.8 ? 'success' : (infoCommercial[up].treated / infoCommercial[up].general) <= 0.3 ? 'error' : 'warning'}
                      sx={{
                        height: 8,
                        borderRadius: 4,
                        backgroundColor: 'action.hover',
                      }}
                    />
                    <Box
                      sx={{
                        alignItems: 'center',
                        display: 'flex',
                        mt: 1
                      }}
                    >
                      <Box sx={{ flexGrow: 1 }} />
                      <Typography
                        color="textSecondary"
                        variant="caption"
                        sx={{ fontWeight: 700 }}
                      >
                        {((infoCommercial[up].treated / infoCommercial[up].general) * 100).toFixed(2)} %
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </Scrollbar>
    </Card>
  );
};
CampaignCard.propTypes = {
  infoCommercial: PropTypes.object.isRequired,
  commercial: PropTypes.object.isRequired,
  setOpenReinjection: PropTypes.func,
  setOpenRetrieve: PropTypes.func,
  setSelectedCommercialReinjection: PropTypes.func,
  setSelectedCommercialRetrieve: PropTypes.func,
  idCampaign: PropTypes.string,
  numberProspectsAttribuable: PropTypes.number
};
export default CampaignCard;
